import { MpRowActionParameters } from '@mp-react/table';

export const recipientStatuses = ['on', 'off'] as const;
export type RecipientStatus = (typeof recipientStatuses)[number];
type RecipientStatusCode = 'ON' | 'OFF';

export interface Recipient {
  id: string;
  parentCompanyId: string;
  name: string;
  employeeCount: number;
  status: RecipientStatus;
  statusCode: RecipientStatusCode;
  newsId: string;
  companyId?: string;
  companyGroupId?: string;
}

export interface RecipientsResponse {
  data: Recipient[];
  count: number;
  pageSize: number;
  footer: {};
}

export interface RecipientsRequestItem {
  employeeGroupId: string;
  companyId?: string;
  companyGroupId?: string;
  status: RecipientStatus;
}

interface SetRecipientStatusParams {
  row: MpRowActionParameters;
}

export type UseNewsRecipientsStore = {
  recipientsData: Recipient[] | null;
  setRecipientsData: (data: Recipient[] | null) => void;
  changedRowIds: string[];
  changedRowCount: number;
  recipientRequest: RecipientsRequestItem[];
  setRecipientRequest: (params: SetRecipientStatusParams) => void;
  resetChanges: () => void;
  setAllRecipients: (recipients: RecipientsRequestItem[]) => void;
};

interface ResponseWarning {
  code: number;
  message: string;
  subCode: number;
}

export interface AssignRecipientsResponse {
  result: boolean;
  warnings: ResponseWarning[];
}
